/* ---------------------------------------------------------------------------
 * MD Fashionwear — recommendation carousel dots
 *
 * THE BUG THIS FIXES
 * Dots were built while the drawer was closed. A closed drawer has zero width,
 * so "cards per view" came out as 1 and ten cards produced ten dots. The count
 * is only knowable once the drawer is on screen.
 *
 * Three triggers, because a drawer can gain width in ways a single one misses:
 *   ResizeObserver on the track   — fires when the drawer opens
 *   MutationObserver on the track — fires when backfill swaps a card
 *   a short polling window        — covers drawers that are shown without any
 *                                   resize event at all
 * ------------------------------------------------------------------------- */

(function () {
  'use strict';

  function build(track, host) {
    if (!track || !host) return false;
    if (track.clientWidth <= 0) return false;

    var first = track.children[0];
    if (!first || !first.offsetWidth) return false;

    var perView = Math.max(1, Math.round(track.clientWidth / (first.offsetWidth + 12)));
    var pages = Math.ceil(track.children.length / perView);

    var existing = host.querySelector('.md-recs__dots');

    if (pages < 2) {
      if (existing) existing.remove();
      return true;
    }

    if (existing && existing.children.length === pages) return true;
    if (existing) existing.remove();

    var bar = document.createElement('div');
    bar.className = 'md-recs__dots';

    for (var i = 0; i < pages; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
      b.setAttribute('aria-label', 'Page ' + (i + 1));
      (function (idx) {
        b.addEventListener('click', function () {
          track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
        });
      })(i);
      bar.appendChild(b);
    }

    host.appendChild(bar);

    if (!track.__mdDotScroll) {
      track.__mdDotScroll = true;
      track.addEventListener('scroll', function () {
        var current = host.querySelector('.md-recs__dots');
        if (!current) return;
        var page = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        [].forEach.call(current.children, function (d, i) {
          d.setAttribute('aria-current', i === page ? 'true' : 'false');
        });
      }, { passive: true });
    }

    return true;
  }

  function watch() {
    var host = document.getElementById('md-recs');
    if (!host) return;
    var track = host.querySelector('.md-recs__track');
    if (!track) return;

    // Poll briefly, because the drawer may become visible without a resize.
    var tries = 0;
    (function attempt() {
      if (build(track, host)) return;
      if (tries++ > 30) return;
      setTimeout(attempt, 250);
    })();

    if (window.ResizeObserver && !track.__mdRO) {
      track.__mdRO = new ResizeObserver(function () { build(track, host); });
      track.__mdRO.observe(track);
    }

    if (window.MutationObserver && !track.__mdMO) {
      track.__mdMO = new MutationObserver(function () { build(track, host); });
      track.__mdMO.observe(track, { childList: true });
    }
  }

  function boot() {
    var tries = 0;
    (function attempt() {
      var host = document.getElementById('md-recs');
      if (host && host.querySelector('.md-recs__track')) { watch(); return; }
      if (tries++ > 40) return;
      setTimeout(attempt, 250);
    })();

    var rerun = function () { setTimeout(watch, 400); };
    document.documentElement.addEventListener('cart:refresh', rerun);
    document.documentElement.addEventListener('cart:change', rerun);
    document.addEventListener('cart:change', rerun);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.MDCartDots = { refresh: watch };
})();
